/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import styled from 'styled-components'

const StyledTextWidget = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`
export default StyledTextWidget
